
<highcharts
  v-if="datas.assetsAndCommunitiesByCountries"
  constructor-type="mapChart"
  :options="chart"
  :key="refreshMap"
/>
